import { labelDefaultMediumStyles, labelDefaultRegularStyles } from '@lifebit-ai/lds'
import styled from 'styled-components'

import { CardHeading, CardLink } from 'ui/card/card.styles'

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['05']};
`

/** Its own card, so it takes the same heading as every other card on these pages. */
export const CardSectionTitle = CardHeading

export const Details = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: ${({ theme }) => theme.size.space['04']};
  column-gap: ${({ theme }) => theme.size.space['06']};
`

export const Label = styled.div`
  ${labelDefaultRegularStyles}
  color: ${({ theme }) => theme.color.content.secondary};
`

export const Value = styled.div`
  ${labelDefaultMediumStyles}
  color: ${({ theme }) => theme.color.content.main};
  font-weight: ${({ theme }) => theme.font.weight.medium};
`

/** The same link the data access pages use. */
export const Link = CardLink
